import api from './api';

export const getTransactionAdmin = (currentPage, PageSize, config) => {
    let errors = [];
    if (!currentPage) {
        errors.push('current page');
    }
    if (!PageSize) {
        errors.push('Page size');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Transaction/GetTransaction?PageNumber=${currentPage}&PageSize=${PageSize}`, config);
    }
}

export const getTransaction = (user, currentPage, PageSize, config) => {
    let errors = [];
    if (!user) {
        errors.push('user');
    }
    if (!currentPage) {
        errors.push('current page');
    }
    if (!PageSize) {
        errors.push('Page size');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Transaction/GetUserTransactions/${user.id}?PageNumber=${currentPage}&PageSize=${PageSize}`, config);
    }
}

export const getOrderStatuses = (config) => {
    let errors = [];
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Order/GetOrderStatuses`, config)
    }
}

export const getById = (user, config) => {
    let errors = [];
    if (!user) {
        errors.push('user');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/users/GetById/${user.id}`, config);
    }
}

export const updateStatus = (value, selectedStatus, config) => {
    let errors = [];
    if (!value) {
        errors.push('value');
    }
    if (!selectedStatus) {
        errors.push('selected status');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.put(`/Transaction/UpdateStatus/${value}/${selectedStatus}`, {}, config);
    }
}
